import { ConnectionModal } from 'modules/auth';
import { BtcConnectionModal } from 'modules/auth/screens/BtcConnectionModal';
import { ILayoutProps, Layout } from 'modules/layout/components/Layout';
import { Footer } from './components/Footer';
import { Header } from './components/Header';

export const DarkSectionHeight = 335;

export function DefaultLayout({
  children,
}: Pick<ILayoutProps, 'children'>): JSX.Element {
  return (
    <Layout headerSlot={<Header />} footerSlot={<Footer />}>
      {children}

      <ConnectionModal />

      <BtcConnectionModal />
    </Layout>
  );
}
